import { render, staticRenderFns } from "./inventarization-item.vue?vue&type=template&id=f1ca0fea&scoped=true"
import script from "./inventarization-item.vue?vue&type=script&lang=js"
export * from "./inventarization-item.vue?vue&type=script&lang=js"
import style0 from "./inventarization-item.vue?vue&type=style&index=0&id=f1ca0fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca0fea",
  null
  
)

export default component.exports